const HideInIframe = ({ reverse, children }) => {
    if (window.parent !== window) {
        if (reverse) {
            return children;
        }

        return null;
    }

    if (reverse) {
        return null;
    }
   
    return children
}

export default HideInIframe;
